import { Controller } from "stimulus"

export default class extends Controller {

  scroll(event) {
    window.scrollTo(0, document.body.scrollHeight);
  }
}